import React, { createContext, useContext, useEffect } from 'react';

/**
 * The app is light-only. Components still read `theme` to choose their colours, so the value stays in
 * the context, but it is always 'light' and nothing can change it: there is no dark palette and no toggle.
 */
export type Theme = 'light' | 'dark';

interface ThemeContextValue {
  theme: Theme;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    document.documentElement.dataset.theme = 'light';
    document.body.dataset.theme = 'light';
    document.body.classList.remove('dark-mode');
  }, []);

  return <ThemeContext.Provider value={{ theme: 'light' }}>{children}</ThemeContext.Provider>;
};

export const useTheme = (): ThemeContextValue => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
};
